import axios from 'axios';
import { Capacitor } from '@capacitor/core';

const API_URL = Capacitor.isNativePlatform()
  ? 'https://app.womsys.nl/api'
  : (process.env.REACT_APP_API_URL || '/api');

const TOKEN_KEY = 'womsys_portal_token';

export function getPortalToken() { return localStorage.getItem(TOKEN_KEY); }
export function setPortalToken(t) { localStorage.setItem(TOKEN_KEY, t); }
export function clearPortalToken() { localStorage.removeItem(TOKEN_KEY); }

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const t = getPortalToken();
  if (t) config.headers['x-portal-token'] = t;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = url.includes('/klantportaal/login') || url.includes('/klantportaal/wachtwoord-instellen');
    if (status === 401 && !isAuthCall) {
      clearPortalToken();
      if (!window.location.hash.includes('login')) {
        window.location.hash = '#/login';
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
